import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=56e67966&lang=pug&"
import script from "./Stores.vue?vue&type=script&lang=js&"
export * from "./Stores.vue?vue&type=script&lang=js&"
import style0 from "./Stores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e67966')) {
      api.createRecord('56e67966', component.options)
    } else {
      api.reload('56e67966', component.options)
    }
    module.hot.accept("./Stores.vue?vue&type=template&id=56e67966&lang=pug&", function () {
      api.rerender('56e67966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/stores/Stores.vue"
export default component.exports